import { TaskInstance } from '@/apps/platform/types/task'
import { stringfy_post } from '@/utils/http'
import { URLS } from './constant'
import { GROUPS } from './permission'

const MENU_DATA = [
  {
    path: '',
    title: '工作台',
    children: [
      {
        path: '/platform/my-task',
        title: '我的任务',
        subs: ['/platform/sub-list', '/platform/we-media-sub-list'],
        userGroups: [GROUPS.LEVEL1_AUDIT, GROUPS.LEVEL2_AUDIT, GROUPS.CONTENT_MODIFY]
      },
      {
        path: '/platform/content-upload',
        title: '内容上传',
        userGroups: [GROUPS.LEVEL1_AUDIT, GROUPS.LEVEL2_AUDIT, GROUPS.CONTENT_MODIFY, GROUPS.ADMIN]
      },
      {
        path: '/platform/content-manage',
        title: '内容管理',
        userGroups: [GROUPS.UPLOAD]
      }
    ]
  },
  {
    path: '',
    title: '任务管理',
    children: [
      {
        path: '/manage/summary',
        title: '任务总览',
        userGroups: [GROUPS.ADMIN]
      },
      {
        path: '/manage/query',
        title: '任务查询',
        userGroups: [GROUPS.LEVEL1_AUDIT, GROUPS.LEVEL2_AUDIT, GROUPS.CONTENT_MODIFY, GROUPS.ADMIN]
      },
      {
        path: '/manage/stat',
        title: '工作量统计',
        userGroups: [GROUPS.LEVEL1_AUDIT, GROUPS.LEVEL2_AUDIT, GROUPS.ADMIN]
      }
    ]
  },
  {
    path: '',
    title: '基础数据管理',
    children: [
      {
        path: '/data/sensitive',
        title: '敏感词库',
        userGroups: [GROUPS.ADMIN]
      },
      {
        path: '/data/image',
        title: '图片样本库',
        userGroups: [GROUPS.ADMIN]
      }
    ]
  },
  {
    path: '',
    title: '系统管理',
    children: [
      {
        path: '/settings/permission',
        title: '权限管理',
        userGroups: [GROUPS.ADMIN]
      },
      {
        path: '/settings/user',
        title: '用户管理',
        userGroups: [GROUPS.ADMIN]
      }
    ]
  }
]

function matchGroups(g1: string[], g2: string[]) {
  for (let g1Item of g1) {
    if (g2.includes(g1Item)) return true
  }
  return false
}

function getFilteredMenuData(groups: string[]) {
  return MENU_DATA.map((menuItem) => {
    let ret = { ...menuItem }
    ret.children = ret.children.filter((item) => matchGroups(item.userGroups, groups))
    return ret
  }).filter((menuItem) => menuItem.children.length > 0)
}

function getCurrentPath(path: string, groups: string[]): { path: string; title: string }[] {
  let ret: { path: string; title: string }[] = []
  ret.push({ path: '', title: '首页' })
  for (let group of getFilteredMenuData(groups)) {
    for (let item of group.children) {
      if (item.path == path || (item.subs && item.subs.includes(path))) {
        ret.push({ path: group.path, title: group.title })
        ret.push({ path: '/cguardian' + item.path, title: item.title })
        return ret
      }
    }
  }
  return ret
}

// 菜单中高亮的url
function getMatchPath(path: string, groups: string[]) {
  for (let group of getFilteredMenuData(groups)) {
    for (let item of group.children) {
      if (item.path == path || (item.subs && item.subs.includes(path))) {
        return item.path
      }
    }
  }
  return path
}

function getOpenKeys(path: string, groups: string[]): string[] {
  for (let group of getFilteredMenuData(groups)) {
    if (group.children.map((item) => item.path).includes(path)) {
      return [group.title]
    }
  }
  return ['工作台']
}

function getConstants() {
  return stringfy_post(URLS.GET_CONSTANTS, {})
}

// 家长大学相关字段取值
function isJzdx(data: TaskInstance) {
  // 判断是否是家长大学的任务, 用来做特殊处理
  return data && data.resource && data.resource.business_type == 6001
}

function get_jzdxUser(data: TaskInstance) {
  return data && data.resource && data.resource.extras && data.resource.extras.comment_user
}

function get_jzdxTopic(data: TaskInstance) {
  return data && data.resource && data.resource.extras && data.resource.extras.topic_text
}

function get_jzdxStand(data: TaskInstance) {
  return data && data.resource && data.resource.extras && data.resource.extras.comment_position
}

function get_jzdxTime(data: TaskInstance) {
  return data && data.resource && data.resource.extras && data.resource.extras.comment_time
}

function get_jzdxComment(data: TaskInstance) {
  return data && data.resource && data.resource.extras && data.resource.extras.comment_content
}

const jzdx = {
  isJzdx,
  get_jzdxUser,
  get_jzdxStand,
  get_jzdxTopic,
  get_jzdxTime,
  get_jzdxComment
}

// 家长大学相关字段取值 end

// 一起学运营相关字段取值
function isYqxyy(data: TaskInstance) {
  return data && data.resource && data.resource.business_type == 6002
}
function get_yqxyyUser(data: TaskInstance) {
  return data && data.resource && data.resource.extras && data.resource.extras.user_id
}
function get_createdAt(data: TaskInstance) {
  return data && data.created_at
}
function get_yqxyyIdiom(data: TaskInstance) {
  return data && data.resource && data.resource.extras && data.resource.extras.idiom
}
function get_yqxyyRejectReason(data: TaskInstance) {
  return (
    data && data.tasks && data.tasks[0].operations && data.tasks[0].operations[0].approve_reason
  )
}

const yqxyy = {
  isYqxyy,
  get_yqxyyUser,
  get_createdAt,
  get_yqxyyIdiom,
  get_yqxyyRejectReason
}

// 直播大讲堂
function isGR(data: any) {
  return data && data.resource && data.resource.business_type == 7002
}

const GR = {
  isGR
}

// 松果AI（首帧截图，举报图片，课程报告音频）相关

const SongGuo = {
  isSongguo(data: TaskInstance) {
    return data && data.resource && data.resource.business_type == 6003
  },

  songGuoCategoryOptions: [
    { label: '开课首帧截图', value: 1 },
    { label: '举报图片', value: 2 },
    { label: '课程报告音频', value: 3 }
  ],

  songguoUrl(data: TaskInstance) {
    return data.resource && data.resource.extras && data.resource.extras.url
  },

  songguoCategory(data: TaskInstance) {
    return data && data.resource && data.resource.category_name
  }
}

// 松果AI（首帧截图，举报图片，课程报告音频）相关 end

// 新增类型-广告
function isAd(data: TaskInstance) {
  return data && data.resource && data.resource.business_type == 7001
}
function get_adTitle(data) {
  return data && data.resource && data.resource.extras && data.resource.extras
}
function get_adSubtitle(data) {
  return data && data.resource && data.resource.extras && data.resource.extras
}
function get_material(data) {
  return data && data.resource && data.resource.extras && data.resource.extras
}

const ad = {
  isAd,
  get_adTitle,
  get_adSubtitle,
  get_material
}

// 新增类型-广告 ed

// 自媒体
function isWeMedia(data: any) {
  return data && data.resource && data.resource.business_type == 8001
}
// 自媒体 / 账号名称
function get_weMediaAccountName(data) {
  return data && data.resource && data.resource.account_name
}
// 自媒体 / 分类
function get_weMediaCategoryName(data) {
  return data && data.resource && data.resource.category_name
}
// 自媒体 / 业务方
function get_weMediaSourceName(data) {
  return data && data.resource && data.resource.source_name
}
// 自媒体 / 上传人
function get_weMediaCreator(data) {
  return data && data.resource && data.resource.creator
}
// 自媒体 / 业务负责人
function get_weMediaOperator(data) {
  return data && data.resource && data.resource.operator
}
// 自媒体 / 预计发布日期
function get_weMediaPublishAt(data) {
  return data && data.resource && data.resource.publish_at
}
// 自媒体 / 内容标题
function get_weMediaTitle(data) {
  return data && data.resource && data.resource.title
}
// 自媒体 / 驳回附件
function get_weMediaAttachment(data) {
  return data.history[0].resource.qiyuan_approve_attachment
}

const weMedia = {
  isWeMedia,
  get_weMediaAccountName,
  get_weMediaCategoryName,
  get_weMediaSourceName,
  get_weMediaCreator,
  get_weMediaOperator,
  get_weMediaPublishAt,
  get_weMediaTitle,
  get_weMediaAttachment
}

// 轻课相关字段取值
function isQk(data: TaskInstance) {
  // 判断是否是家长大学的任务, 用来做特殊处理
  return data && data.resource && data.resource.business_type == 6004
}
const qk = {
  isQk
}
// 判断URL类型
function ResourceType(href: string) {
  let _href = (href || '').toLowerCase()

  const imgSurfix = 'bmp,jpg,png,tif,gif,pcx,tga,exif,fpx,svg,psd,cdr,pcd,dxf,ufo,eps,ai,raw,WMF,webp,jpeg'
    .split(',')
    .map((item) => item.trim())
    .map((item) => item.toLowerCase())
  const audioSurfix = 'mp3,wma,avi,rm,rmvb,flv,mpg,mov,mkv,sy3,ogg'
    .split(',')
    .map((item) => item.trim())
    .map((item) => item.toLowerCase())

  return {
    isImage() {
      for (let surfix of imgSurfix) {
        if (_href.endsWith('.' + surfix)) {
          return true
        }
      }
      return false
    },
    isAudio() {
      for (let surfix of audioSurfix) {
        if (_href.endsWith('.' + surfix)) {
          return true
        }
      }
      return false
    }
  }
}

// 缓存上次的管理员email
type CacheKeyType = 'CACHE_LS_ADMIN_EMAIL'
const Cache = {
  write(key: CacheKeyType, val: string) {
    localStorage.setItem(key, val)
  },
  read(key: CacheKeyType) {
    return localStorage.getItem(key)
  }
}
// 浏览器类型判断
function myBrowser() {
  const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  const isOpera = userAgent.indexOf('Opera') > -1
  if (isOpera) {
    return 'Opera'
  } // 判断是否Opera浏览器
  if (userAgent.indexOf('Firefox') > -1) {
    return 'FF'
  } // 判断是否Firefox浏览器
  if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome'
  }
  if (userAgent.indexOf('Safari') > -1) {
    return 'Safari'
  } // 判断是否Safari浏览器
  if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
    return 'IE'
  } // 判断是否IE浏览器
}

export {
  getCurrentPath,
  getOpenKeys,
  getMatchPath,
  getConstants,
  getFilteredMenuData,
  jzdx,
  yqxyy,
  GR,
  Cache,
  SongGuo,
  ad,
  ResourceType,
  myBrowser,
  weMedia,
  qk
}
